export default "__VITE_ASSET__B_q60tTM__"